import * as Config from '../../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Content from '../../../../common/Content';
import SubMenu from '../../../../common/SubMenu';
import GridGenresV2 from '../../../../content/grid/GridGenresV2';

import usePageScroll from '../../../../../../hooks/usePageScroll';

import './Container.css';

function ConnectedContainer({ user, dimension }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;
 
  const noFilter = (base, x) => {
    base.push(x);
    return base;
  }

  const filterName = (base, x, i) => {
    if (x.genre) {
      if (!base.some( y => y.name === x.name)) {
        base.push(x);
      }
    }
    return base;
  }

  const filterGenre = (base, x, i) => {
    if (x.genre) {
      x.name = x.genre.name;
      if (!base.some( y => y.name === x.name)) {
        base.push(x);
      }
    }
    return base;
  }

  const playlists = [
    { id: 46095, name: 'The20', slug: 'the20', customReduceFormat: noFilter },
    { id: 47907, name: 'Monthly Top Picks', slug: 'monthly-top-picks', customReduceFormat: filterGenre  },
    { id: 48298, name: 'Club Sets', slug: 'club-sets', customReduceFormat: filterName },
    { id: 48301, name: 'Learn-To-Mix', slug: 'learn-to-mix', customReduceFormat: filterName },
    { id: 48309, name: 'Weddings', slug: 'weddings', customReduceFormat: filterName },
    { id: 48295, name: 'New Hits & Must-Haves', slug: 'new-hits-must-haves', customReduceFormat: filterGenre },
    { id: 112803, name: 'Open Format Sets', slug: 'open-format-sets', customReduceFormat: filterName },
    { id: 48333, name: 'Decades Collections', slug: 'decades-collections', customReduceFormat: filterName },
  ]

  let { onScroll } = usePageScroll();

  return (
    <div className={`featured-playlists-page`} style={{ height }} onScroll={onScroll}>
      <Content name={`Playlists`} isSticky={true} 
        stickyClassName={`sticky-menu-featured-playlists`}
        contentClassName={`content-featured-playlists`}
        styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
        subContent={(
          <div className={`flexRow featured-playlists-menu`}>
            { playlists.map( (p,i) => <SubMenu 
                key={`playlist-type-${p.id}`} 
                to={`${url}/${p.slug}`} 
                or={ i === 0 ? `${url}` : null} label={p.name} /> )}
          </div>
        )}
      >
        <Switch>
          <Route exact path={`${url}`}>
            <GridGenresV2 
              title={`All Genres`}
              id={`The20`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=46095&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              showTitle={true}
              customReduceFormat={noFilter}
              rowHeight={200}
            />
          </Route>
          { playlists.map( p => (
            <Route exact path={`${url}/${p.slug}`}>
              <GridGenresV2 
                title={`All Genres`}
                id={p.slug} 
                width={width} 
                pathApi={`/catalog/charts/?enabled=true&is_published=true&owner_id=${p.id}`}
                showLoading={true}
                showTitle={true}
                customReduceFormat={p.customReduceFormat}
                rowHeight={200}
              />
            </Route>
          ))}
        </Switch>
      </Content>
    </div>
  );
}

ConnectedContainer.propTypes = {
  user: PropTypes.object,
  dimension: PropTypes.object
}

const Container = connect(
  state => ({
    user: state.user,
    dimension: state.dimension
  })
)(ConnectedContainer);

export default Container;
